import script from "./projects-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./projects-grid.vue?vue&type=script&setup=true&lang=js"

import "./projects-grid.vue?vue&type=style&index=0&id=425fd603&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425fd603"]])

export default __exports__